import Button from "@pathwright/ui/src/components/button/Button"
import { ConnectForm } from "lib/core/components/forms"
import { ConnectStores } from "lib/core/store/"
import PropTypes from "prop-types"

const getContentFormComponent = function ({ fieldsData, renderForm, key }) {
  const Form = (props) => (
    <form className="ContentMethod__FormWrapper">
      {renderForm(props)}
      <footer>
        <Button styleType="blank" onClick={props.handleCancel}>{`\
Cancel\
`}</Button>
        <Button styleType="default" onClick={props.handleSubmit}>
          {props.prompt}
        </Button>
        <aside>{props.aside}</aside>
      </footer>
    </form>
  )

  const ConnectedForm = ConnectForm(Form, fieldsData)
  ConnectedForm.displayName = `ConnectedForm${key}`

  return ConnectedForm
}

const getContentFormContainer = function (method) {
  const { getValues, getSaveData } = method

  const FormComponent = getContentFormComponent(method)

  const mapStateToProps = function (state, ownProps) {
    const { selection } = state.contentAdminStore.state
    const { step } = state.stepStore.state
    const { saveContent, clearContent } = state.contentAdminStore.action

    const fieldValues = getValues(selection)

    const prompt = step.last_published_dtime ? "Save & Publish" : "Save"
    const aside = step.last_published_dtime
      ? "Changes will be live everywhere this content is used."
      : undefined

    const onSubmit = function (fieldsData) {
      const contentData = getSaveData(fieldsData)
      return saveContent(contentData)
    }

    const handleCancel = () => clearContent()

    return _.assign(
      {},
      {
        onSubmit,
        handleCancel,
        fieldValues,
        prompt,
        aside
      },
      ownProps
    )
  }

  const stores = [
    { store: "contentAdmin", watch: ["selection"] },
    { store: "step", watch: false }
  ]

  const FormContainer = ConnectStores(
    FormComponent,
    stores,
    {},
    mapStateToProps
  )
  FormContainer.displayName = "FormContainer"
  FormContainer.propTypes = {
    method: PropTypes.shape({
      fieldsData: PropTypes.object.isRequired,
      renderForm: PropTypes.func.isRequired,
      getValues: PropTypes.func.isRequired,
      getSaveData: PropTypes.func.isRequired
    })
  }

  return FormContainer
}

export default { getContentFormComponent, getContentFormContainer }
